import React from "react";
import DotsComponent from "../DotsComponent";
import './Finance.css'

const FinanceTableRender = (props) => {
  return props.data.map((val) => {
    return (
      <div className="current-table">
      {/* <DotsComponent/> */}
        <h3>CURRENT ASSESTS</h3>
        <table className="table_">
          <tr className="table_background">
            <th style={{color:"#fff"}}><p>Current Assets</p></th>
            <td style={{color:"#fff"}}>{val.currentassets}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Cash</th>
            <td>{val.cash}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Account Receivable</th>
            <td>{val.accountReceivable}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Inventory</th>
            <td>{val.inventry}</td>
          </tr>
          <tr className="assests-table-row">
            <th>Pre-Paid Expenses</th>
            <td>{val.prepaidExpense}</td>
          </tr>
        </table>
      </div>
    );
  });
};

export default FinanceTableRender;
